import { Button } from "@mui/material";
import {
  MajorButtonComponent,
  PinInputComponent,
  SpinnerComponent,
} from "@zenith/components";
import { memo } from "react";

interface PaymentsPinPageComponentProps {
  hasError: boolean | undefined;
  id: string;
  isContinueButtonDisabled: boolean;
  labelText: string;
  newPin: Array<number | string>;
  onBlur: () => void;
  onContinueButtonClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
  onPinChanged: (pinEntry: string | number, index: number) => void;
  pinLength: number;
  subtitle: string;
  title: string;
  validationMessage: string;
  isLoading?: boolean;
}

const PaymentsPinPageComponent = memo(function PaymentsPinPageComponent(
  props: PaymentsPinPageComponentProps
) {
  return (
    <div className="mx-2 mt-5 w-full rounded-[20px] border border-neutral-200 lg:w-4/5 xl:w-3/5">
      <div className="w-full rounded-2.5xl bg-white py-6 px-2 sm:px-8">
        <div className="flex-col justify-between">
          <h1 className="mb-6 text-2xl font-medium text-neutral-900">
            {props.title}
          </h1>
          <p className="mb-12 text-sm font-normal text-neutral-500">
            {props.subtitle}
          </p>
        </div>

        <div
          className={`${
            props.pinLength === 4
              ? "w-full max-w-[14rem] md:w-1/2 lg:w-3/5 lg:max-w-[18rem] xl:w-1/2"
              : "w-full max-w-xs md:w-3/5 md:max-w-md lg:w-4/5 xl:w-3/4"
          }`}
        >
          <PinInputComponent
            id={`${props.id}-pin`}
            label={props.labelText}
            labelClassName="mb-2 text-zinc-500 text-sm"
            pinLength={props.pinLength}
            pinContainerClass="gap-2 md:gap-4 xl:gap-6"
            pin={props.newPin}
            type={"tel"}
            masked={true}
            onPinChanged={props.onPinChanged}
            onBlur={props.onBlur}
            hasError={props.hasError}
            validationMessage={props.validationMessage}
          />
        </div>

        <div className="mt-60 flex justify-center">
          <MajorButtonComponent
            id={`${props.id}-pin-continue-button`}
            onClick={props.onContinueButtonClick}
            type="submit"
            disabled={props.isContinueButtonDisabled || props.isLoading}
            buttonType="primary"
            size="large"
          >
            {props.isLoading ? (
              <>
                <SpinnerComponent type={"primary"} size={20} />
                <span className="ml-2">Continue</span>
              </>
            ) : (
              "Continue"
            )}
          </MajorButtonComponent>
        </div>
      </div>
    </div>
  );
});

export default PaymentsPinPageComponent;
